import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import Loader from '../partial/Loader';
import { customerView, Internal_Token, ssoLogin } from '../auth/auth';
import { encrypt } from '../../utils/encodingdecoding';
import { NEW_PROJECT_ACCESS_KEY } from '../../utils/constant';

function SignIn() {
    
    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [error, setError] = useState('');
    const [loader, setLoader] = useState(false);
  useEffect(() => {
    localStorage.clear();
    sessionStorage.clear();
  }, []);
    const getToken = async () => {
        const tokenData = localStorage.getItem('token_gen');
        let accessToken = null;

        if (tokenData) {
            try {
                const token = JSON.parse(tokenData);
                if (token?.access_token && (!token.expires_at || Date.now() < token.expires_at * 1000)) {
                    return token.access_token;
                }
            } catch (e) {
                console.error('Failed to parse token:', e);
            }
        }

        const tokenBody = {
            clientid: encrypt(process.env.REACT_APP_CLIENT_ID || 'progcap_180225062305638754565883678805'),
            grant_type: 'client_credentials',
            clientsecret: encrypt(process.env.REACT_APP_CLIENT_SECRET || 'YTVAQBLCNR'),
        };

        const internalToken = await Internal_Token(tokenBody);
        if (!internalToken?.access_token) {
            throw new Error('Failed to retrieve valid token');
        }

        const tokenToStore = {
            access_token: internalToken.access_token,
            expires_at: internalToken.expires_in
                ? Math.floor(Date.now() / 1000) + internalToken.expires_in
                : Math.floor(Date.now() / 1000) + 3600,
        };
        localStorage.setItem('token_gen', JSON.stringify(tokenToStore));
        return internalToken.access_token;
    };

    useEffect(() => {
    
        const ssoAuthLogin = async () => {
            const access_key = searchParams.get('access_key');
            if (!access_key) {
                setError('No access key provided. Please log in again.');
                return;
            }
            setLoader(true);
            try {
                const accessToken = await getToken();
                const ssoRes = await ssoLogin(accessToken, access_key);
                if (ssoRes.message === 'Request processed successfully.') {
                    localStorage.clear()
                    localStorage.setItem('customercode', ssoRes.data.customercode);
                    const profileData = await customerView(accessToken, ssoRes.data.customercode);
                    localStorage.setItem('customerTier', profileData?.customer?.customertier);
                    localStorage.setItem('customerid', profileData?.customer?.companyid);
                    localStorage.setItem('industry', profileData?.customer?.industry);
                    localStorage.setItem("quarterlypoints", profileData?.customer?.quarterlypoints);
                    localStorage.setItem("npaBreached", profileData?.customer?.npaBreached);
                    localStorage.setItem('InvoiceEarningsStatus', profileData?.customer?.InvoiceEarningsStatus);

                    localStorage.setItem("earnedValue", profileData?.walletsDetail?.earnedValue)
                    if (access_key === NEW_PROJECT_ACCESS_KEY) {
                        localStorage.setItem("portal", "new_app")
                    }
                    navigate('/home');
                } else {
                    throw new Error(ssoRes.message || 'SSO login failed');
                }
            } catch (error) {
                setError(
                    error.message === 'Invalid access_key'
                        ? 'Invalid access key. Please try again or contact support.'
                        : 'Failed to process login. Please try again later.'
                );
            } finally {
                setLoader(false);
            }
        };

        if (location.pathname.includes('sso-login')) {
            ssoAuthLogin();
        }
    }, [location, navigate, searchParams]);

    return (
        <section className="section signUpPage newStyle">
            {loader && <Loader />}
            {error && (
                <div className="error-message">
                    {error}
                </div>
            )}
        </section>
    );
}

export default SignIn;
